(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    for (const intent of ['related','complementary']) {
      const url = new URL(root.dataset.url, location.origin);
      url.search = new URLSearchParams({section_id:root.dataset.sectionId,product_id:root.dataset.productId,limit:'10',intent});
      fetch(url, {credentials:'same-origin'}).then(r => { if (!r.ok) throw Error('Recommendations unavailable'); return r.text(); }).then(html => {
        const doc = new DOMParser().parseFromString(html,'text/html');
        const content = doc.querySelector(`[data-suggestion-kind="${intent}"] [data-suggestion-content]`);
        const target = root.querySelector(`[data-suggestion-kind="${intent}"] [data-suggestion-content]`);
        if (content && target && Number(content.dataset.count) > 0) target.replaceWith(content);
      }).catch(() => { /* Keep the server-rendered catalog fallback. */ });
    }
  };
  const boot = scope => scope.querySelectorAll('[data-rv-suggestions]').forEach(root => {
    if (!('IntersectionObserver' in window)) return init(root);
    const observer = new IntersectionObserver(entries => {if(entries.some(e=>e.isIntersecting)){observer.disconnect();init(root);}},{rootMargin:'350px'});observer.observe(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>boot(document));else boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
